import { Component, Input} from '@angular/core';
import { AppService } from '../../App/app.service';
import { GeneralComponent } from '../../General/g.component';

@Component({
  selector: 'app-show-example',
  templateUrl: './show-example.component.html',
  styleUrls: ['./show-example.component.css']
})
export class ShowExampleComponent {

  @Input() gif: string;
  @Input() tipName: string;
  showVideo: boolean = true;
  showTip: boolean = true;

  constructor(protected appService: AppService) { 
  }

  ngOnInit(){
    this.showTip = this.appService.showTip('showVideo');
    this.showVideo = this.appService.showTip(this.tipName, true);
    this.appService.closeTip(this.tipName);
  }

   /** get text in right language 
  * @param {string} tag - text to load
  */
 get(tag:string):string {
  return this.appService.get(tag);
}




}
